import { Image } from "@mantine/core";

import logoOnDark from "./assets/created-ai-logo-dark.svg";
import logoOnLight from "./assets/created-ai-logo.svg";

export interface LogoProps {
  /** 130 by 18 in the header, 190 by 25 on sign-in (design-system.md 2.2, 3.1). */
  width?: number;
  height?: number;
}

/**
 * The created.ai wordmark, eJam's brand file: dark text on the light scheme, white on dark. Both
 * files render and the scheme's CSS hides one, so the first paint already shows the right one.
 * Its colours are the brand's in every theme family (Daniil, 2026-10-29: "It's a brand coloring"):
 * never a theme token, and no style may reach them (spec web/themes-brand-logo).
 */
export function Logo({ width = 130, height = 18 }: LogoProps) {
  return (
    <>
      <Image src={logoOnLight} alt="Created.ai" w={width} h={height} fit="contain" darkHidden />
      <Image src={logoOnDark} alt="Created.ai" w={width} h={height} fit="contain" lightHidden />
    </>
  );
}
